
<div class="custom-progress progress" role="progressbar" aria-label="Basic example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
    <img src="../../assets/img/open_in_new_down.svg"/> <p style="font-weight:bold;  padding-left: 1rem;">{{data.text}}</p> &nbsp;<div [ngClass]="data.text" class="progress-bar" [style.width.%]="data.percentage"></div> &nbsp;{{data.percentage}}%
</div>